import React, {Component} from 'react'
import {StyleSheet, View, Dimensions, ScrollView, TextInput} from 'react-native'
import {Text, Input, Button} from 'react-native-elements'

import {create} from './network'
import TimePoint from './TimePoint'
import Media from './Media'

import cloneDeep from 'lodash/cloneDeep'
const VIEW_WIDTH = Dimensions.get('window').width / 1.5
const INPUT_WIDTH = VIEW_WIDTH / 2.5

const DATA = {
  type: 0,
  body: '',
  timepoint: 0,
}

class Create extends Component {
  constructor (props) {
    super(props)
    this.state = {
      timeLineData: [DATA],
      title: '',
      url: '',
      isMediaOpen: false,
      isMediaOpenForTimeLine: false,
      timeLineIndex: -1,
      isLoading: false,
    }
  }

  addMore = () => {
    let existing = cloneDeep(this.state.timeLineData)
    existing.push(DATA)
    this.setState({
      timeLineData: existing,
    })
  }

  timePointChange = (index, data) => {
    const existing = cloneDeep(this.state.timeLineData)
    existing[index] = data
    this.setState({
      timeLineData: existing,
    })
  }
  removeTiming = index => {
    const existing = cloneDeep(this.state.timeLineData)
    existing.splice(index, 1)
    this.setState({
      timeLineData: existing,
    })
  }
  selectFileForTimePoint = index => {
    this.setState({
      isMediaOpenForTimeLine: true,
      timeLineIndex: index,
    })
  }

  loadTimeLineInputs = () => {
    let inputs = []
    this.state.timeLineData.forEach((timing, index) => {
      inputs.push(
        <TimePoint
          key={index}
          default={timing}
          data={data => this.timePointChange(index, data)}
          removeTiming={() => this.removeTiming(index)}
          onSelectFileForTimePoint={() => this.selectFileForTimePoint(index)}
        />,
      )
    })

    return inputs
  }

  loadSettingHeader = () => (
    <View style={styles.settingHeaderViewStyle}>
      <Text style={styles.settingHeaderTextStyle}>
        Select time point and it's content below:{' '}
      </Text>
    </View>
  )

  save = () => {
    this.setState({
      isLoading: true,
    })
    create(this.state.title, this.state.url, this.state.timeLineData)
      .then(data => {
        this.setState({
          isLoading: false,
        })
        this.props.onCreateCancelPress()
      })
      .catch(error => {
        this.setState({
          isLoading: false,
        })
        this.props.onCreateCancelPress()
      })
  }

  titleChange = text => this.setState({title: text})
  urlChange = text => this.setState({url: text})

  loadTitleInputView = () => {
    return (
      <View style={styles.inputViewStyle}>
        <Text style={styles.labelStyle}>Put your video title here *</Text>
        <TextInput
          style={styles.inputTitleStyle}
          placeholder={'Title'}
          onChangeText={this.titleChange}
          value={this.state.title}
        />
      </View>
    )
  }

  onSelectMediaButtonPress = () => {
    this.setState({
      isMediaOpen: true,
    })
  }

  loadUrlInputView = () => {
    return (
      <View style={styles.inputViewStyle}>
        <Text style={styles.labelStyle}>Put your video link here *</Text>
        <TextInput
          style={styles.urlInputStyle}
          placeholder={'Paste link or click select'}
          onChangeText={this.urlChange}
          textContentType={'URL'}
          value={this.state.url}
        />
        <Button
          buttonStyle={styles.createButtonStyle}
          title={'SELECT'}
          titleStyle={styles.createButtonTitleStyle}
          onPress={this.onSelectMediaButtonPress}
          icon={{
            name: 'link',
            type: 'font-awesome-5',
            size: 15,
            color: 'white',
          }}
          containerStyle={styles.selectButtonStyle}
        />
      </View>
    )
  }

  loadAddMoreButtonView = () => {
    return (
      <Button
        icon={{
          name: 'plus',
          size: 15,
          color: 'white',
          type: 'font-awesome-5',
        }}
        title='ADD'
        onPress={this.addMore}
        buttonStyle={styles.addMoreButtonStyle}
        titleStyle={styles.addMoreButtonTitleStyle}
      />
    )
  }
  loadSaveOrCancelButtonView = () => {
    return (
      <View style={styles.saveOrCancelButtonStyle}>
        <Button
          buttonStyle={styles.cancelButtonStyle}
          title={'CANCEL'}
          titleStyle={styles.cancelButtonTitleStyle}
          onPress={this.props.onCreateCancelPress}
        />
        <Button
          buttonStyle={styles.createButtonStyle}
          title={'SAVE'}
          titleStyle={styles.createButtonTitleStyle}
          onPress={this.save}
          loading={this.state.isLoading}
        />
      </View>
    )
  }

  onFileSelect = data => {
    if (this.state.isMediaOpenForTimeLine) {
      let existing = cloneDeep(this.state.timeLineData)
      existing[this.state.timeLineIndex]['body'] = data.source_url
      this.setState({
        timeLineData: existing,
        isMediaOpen: false,
        isMediaOpenForTimeLine: false,
        timeLineIndex: -1,
      })
    } else {
      this.setState({
        url: data.source_url,
        isMediaOpen: false,
        isMediaOpenForTimeLine: false,
      })
    }
  }
  onFileSelectCancelPress = () => {
    this.setState({
      isMediaOpen: false,
      isMediaOpenForTimeLine: false,
      timeLineIndex: -1,
    })
  }

  render () {
    return (
      <View style={styles.container}>
        {this.state.isMediaOpen || this.state.isMediaOpenForTimeLine ? (
          <Media
            mediaType={this.state.isMediaOpenForTimeLine ? '' : 'video'}
            onFileSelect={this.onFileSelect}
            onFileSelectCancelPress={this.onFileSelectCancelPress}
          />
        ) : (
          <View style={styles.elementStyle}>
            {this.loadTitleInputView()}
            {this.loadUrlInputView()}
            {this.loadSettingHeader()}
            {this.loadTimeLineInputs()}
            {this.loadAddMoreButtonView()}
            {this.loadSaveOrCancelButtonView()}
          </View>
        )}
      </View>
    )
  }
}

const styles = StyleSheet.create({
  labelStyle: {
    flex: 0.5,
  },
  inputTitleStyle: {
    flex: 0.5,
  },

  urlInputStyle: {
    flex: 0.3,
  },
  selectButtonStyle: {
    flex: 0.2,
  },

  saveOrCancelButtonStyle: {
    flexDirection: 'row',
    width: VIEW_WIDTH,
    justifyContent: 'flex-end',
  },
  createButtonTitleStyle: {
    color: 'white',
    fontSize: 15,
  },
  cancelButtonTitleStyle: {
    color: 'black',
    fontSize: 15,
  },
  createButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: '#007599',
    borderRadius: 2,
    marginHorizontal: 20,
  },
  addMoreButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: 'green',
    borderRadius: 2,
    marginHorizontal: 20,
  },
  addMoreButtonTitleStyle: {
    color: 'white',
    fontSize: 15,
  },
  cancelButtonStyle: {
    width: 100,
    height: 30,
    backgroundColor: '#eeeeee',
    borderRadius: 2,
  },
  settingHeaderViewStyle: {
    flexDirection: 'row',
    width: VIEW_WIDTH,
    justifyContent: 'flex-start',
    margin: 20,
  },
  settingHeaderTextStyle: {
    fontSize: 18,
  },
  inputStyle: {
    width: INPUT_WIDTH,
    margin: 15,
  },
  inputViewStyle: {
    width: VIEW_WIDTH,
    margin: 15,
    flexDirection: 'row',
  },
  elementStyle: {
    width: VIEW_WIDTH,
    alignItems: 'center',
  },
  container: {
    flex: 1,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 20,
  },
})

export default Create
